import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { RevealText, Reveal } from "@/components/Reveal";
import Img from "@/components/Img";
import { JOURNAL } from "@/data/content";

export default function Journal() {
  const hasPosts = JOURNAL.posts && JOURNAL.posts.length > 0;

  return (
    <div className="pt-8 md:pt-12">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10">
        <p className="overline text-sage mb-6">{JOURNAL.eyebrow}</p>
        <RevealText
          as="h1"
          className="font-serif font-light text-ink leading-[0.95] tracking-tight text-5xl sm:text-6xl md:text-7xl"
          lines={["Stories from", "behind the lens"]}
        />
        <Reveal delay={0.25}>
          <p className="mt-8 max-w-xl text-inksoft leading-relaxed">
            {JOURNAL.blurb}
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 mt-20 md:mt-28 pb-28">
        {hasPosts ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 md:gap-x-16 gap-y-20 md:gap-y-28">
            {JOURNAL.posts.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 2) * 0.08}>
                <Link
                  to={`/journal/${p.slug}`}
                  data-testid={`journal-card-${p.slug}`}
                  className="group block"
                >
                  <div className="overflow-hidden">
                    <Img
                      src={p.hero}
                      alt={p.title}
                      className="aspect-[4/5]"
                      imgClassName="group-hover:scale-[1.04] transition-transform duration-700 ease-out"
                    />
                  </div>
                  <div className="mt-6 flex items-center gap-3 text-xs tracking-[0.16em] uppercase text-inksoft">
                    <span>{p.date}</span>
                    <span className="h-px w-6 bg-ink/20" />
                    <span className="text-sage">{p.category}</span>
                  </div>
                  <h2 className="mt-4 font-serif font-light text-ink text-3xl md:text-4xl leading-[1.05] tracking-tight group-hover:text-sage transition-colors">
                    {p.title}
                  </h2>
                  {p.excerpt && (
                    <p className="mt-4 text-inksoft leading-relaxed max-w-lg">
                      {p.excerpt}
                    </p>
                  )}
                  <span className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.16em] uppercase text-ink">
                    Read the story
                    <ArrowUpRight
                      size={14}
                      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal>
            <div
              data-testid="journal-empty"
              className="border border-ink/10 bg-sagelight/40 px-8 md:px-16 py-20 md:py-28 max-w-3xl"
            >
              <p className="overline text-sage mb-4">Coming soon</p>
              <h2 className="font-serif font-light text-ink text-3xl md:text-4xl leading-tight tracking-tight">
                {JOURNAL.emptyTitle}
              </h2>
              <p className="mt-6 text-inksoft leading-relaxed max-w-xl">
                {JOURNAL.emptyBody}
              </p>
            </div>
          </Reveal>
        )}
      </section>
    </div>
  );
}
